import { Box, TextField } from "@mui/material";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import GenericFilterBox from "../common/GenericFilterBox";
import { CarrierList } from "./Type";

interface Props {
  searchData: CarrierList.SearchFunctionDataType;
  setSearchData: (value: CarrierList.SearchFunctionDataType) => void;
  setFormData: (value: CarrierList.SearchFunctionDataType) => void;
  resetData: () => void;
  refreshTable: () => void;
}

const SearchCarrierModal = (props: Props) => {
  const t = useOperationTranslation();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.setSearchData({
      ...props.searchData,
      [event.target.name]: event.target.value,
    });
  };

  const SubmitForm = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    props.setFormData(props.searchData);
  };

  return (
    <form
      id="searchForm"
      onSubmit={(event: React.FormEvent<HTMLFormElement>) => SubmitForm(event)}
    >
      <GenericFilterBox
        formId="searchForm"
        showExtrasFilters={false}
        onReset={props.resetData}
      >
        <Box>
          <TextField
            variant="standard"
            fullWidth
            id="name"
            name="name"
            value={props.searchData?.name || ""}
            label={t("carrier.table.name")}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              handleChange(event)
            }
            inputProps={{
              pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
              onInput: (event) => {
                if (event.currentTarget.validity.patternMismatch) {
                  event.currentTarget.setCustomValidity(
                    t("vehicle.filterModal.regexMessage")
                  );
                } else {
                  event.currentTarget.setCustomValidity("");
                }
              },
            }}
          />
        </Box>
        <Box>
          <TextField
            variant="standard"
            fullWidth
            id="bpCode"
            name="bpCode"
            value={props.searchData?.bpCode || ""}
            label={t("carrier.table.bpCode")}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              handleChange(event)
            }
            inputProps={{
              pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
              onInput: (event) => {
                if (event.currentTarget.validity.patternMismatch) {
                  event.currentTarget.setCustomValidity(
                    t("vehicle.filterModal.regexMessage")
                  );
                } else {
                  event.currentTarget.setCustomValidity("");
                }
              },
            }}
          />
        </Box>
      </GenericFilterBox>
    </form>
  );
};

export default SearchCarrierModal;
